module.exports = __webpack_public_path__ + "fonts/fa-duotone-900.e084f1c8.ttf";